import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  transactions: [],
};

const dashBoardRecentTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_RECENT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Roles fetch successfully",
        transactions: action.payload.data,
      };
    case TYPE.GET_RECENT_TRANSACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching roles",
        transactions: [],
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default dashBoardRecentTransactionReducer;
